import React from "react";
import ComeBackTimer from "../../ComeBackTimer";

const Screen29 = () => {
    return <ComeBackTimer />;
};

export default Screen29;
